import styled from 'styled-components';
import { formatToEokMan } from '../../../../func/Function';
import { useEffect, useState } from 'react';
import UnitSwitch from '../../../../func/components/UnitSwitch';
import Tab from './Tab';
import {
  AroundRealDealFilter,
  RealDealData,
  RealDealDataItem,
} from '../../data';
import { useReportContext } from '../../../../context/DetailContext';
import Pagination from '../../../components/pagination/Pagination';
import DetailService from '../../../../service/detail';
// 인근 물건 실거래가
function NearRealPrice() {
  const { iidx, itemType, zoning, type, exchangeItemCategory } =
    useReportContext();

  const [nearRealPriceData, setNearRealPriceData] = useState<RealDealData>(); //주변실거래가
  const [aroundRealDealFilter, setAroundRealDealFilter] =
    useState<AroundRealDealFilter>({
      iidx: Number(iidx) ?? 0,
      b_idx: 0,
      distance: 500,
      limit: 6,
      offset: 0,
      is_same_arround1: false,
      is_same_arround2: false,
    });

  const [acitveTab, setAcitveTab] = useState('매매');
  const [nearRealPriceList, setNearRealPriceList] = useState<
    RealDealDataItem[]
  >([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [unit, setUnit] = useState('평');

  const getAroundRealDealPriceList = async (data: AroundRealDealFilter) => {
    try {
      const {
        iidx,
        b_idx,
        distance,
        limit,
        offset,
        is_same_arround1,
        is_same_arround2,
      } = data;
      const res = await DetailService.aroundRealDealPrice(
        iidx,
        b_idx,
        distance,
        limit,
        offset,
        is_same_arround1,
        is_same_arround2,
      );
      setNearRealPriceData(res.data);
    } catch (e) {
      console.log(e);
    }
  };

  //인근 물건 실거래가 조회
  useEffect(() => {
    if (iidx !== '') {
      getAroundRealDealPriceList(aroundRealDealFilter);
    }
  }, [iidx, aroundRealDealFilter]);

  useEffect(() => {
    if (nearRealPriceData) {
      switch (acitveTab) {
        case '매매':
          setNearRealPriceList(nearRealPriceData.sale);
          break;
        case '전월세':
          setNearRealPriceList(nearRealPriceData.jeonse);
          break;
        default:
          setNearRealPriceList(nearRealPriceData.sale);
          break;
      }
    }
  }, [acitveTab, nearRealPriceData]);

  function calculateElapsedYears(buildYear: string): number | null {
    if (!buildYear) return null;

    const currentYear = new Date().getFullYear();

    // 연도만 있는 경우 (예: "2001")
    if (/^\d{4}$/.test(buildYear)) {
      return currentYear - parseInt(buildYear, 10);
    }

    // 연,월,일 모두 있는 경우 (예: "20010331")
    if (/^\d{8}$/.test(buildYear)) {
      const year = parseInt(buildYear.slice(0, 4), 10);
      return currentYear - year;
    }

    // 지원하지 않는 형식일 경우
    return null;
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page);

    setAroundRealDealFilter({
      ...aroundRealDealFilter,
      offset: (page - 1) * 6,
    });
  };

  if (
    aroundRealDealFilter.is_same_arround1 === false &&
    aroundRealDealFilter.is_same_arround2 === false &&
    acitveTab === '매매' &&
    nearRealPriceList.length === 0
  )
    return null;

  return (
    <Container>
      <ContentItemTitle>
        <TitleWrapper>
          <TitleWithCheckbox>
            <TitleBox>
              <TitleContent>
                <img src="/assets/images/icon/icon_sameAddress.svg" alt="" />
                <div>인근 물건 실거래가</div>
              </TitleContent>
              <UnitSwitch unit={unit} setUnit={setUnit} />
            </TitleBox>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '6px',
              }}
            >
              {type === 'e' ? (
                <BlueTag>{exchangeItemCategory}</BlueTag>
              ) : nearRealPriceData?.ptype ? (
                <>
                  <BlueTag>{nearRealPriceData?.ptype}</BlueTag>
                  {!['토지', '주차장', '빌딩', '기타'].includes(
                    nearRealPriceData?.ptype ?? '',
                  ) && <BlueTag>{nearRealPriceData?.ptype2}</BlueTag>}
                  {nearRealPriceData?.ptype === '토지' && (
                    <BlueTag>{zoning}</BlueTag>
                  )}
                </>
              ) : null}
              <BlueTag>
                반경{' '}
                {aroundRealDealFilter.distance === 500
                  ? '500m'
                  : aroundRealDealFilter.distance % 1000 === 0
                    ? `${aroundRealDealFilter.distance / 1000}km`
                    : `${(aroundRealDealFilter.distance / 1000).toFixed(1)}km`}
              </BlueTag>
            </div>
            <CheckboxWrapper>
              <Checkbox
                $isOn={aroundRealDealFilter.is_same_arround1}
                onClick={() =>
                  setAroundRealDealFilter({
                    ...aroundRealDealFilter,
                    is_same_arround1: !aroundRealDealFilter.is_same_arround1,
                  })
                }
              >
                <img
                  src={`/assets/images/check/${aroundRealDealFilter.is_same_arround1 ? 'circle-checked-blue' : 'circle-checked-gray-outline'}.svg`}
                  alt=""
                />
                동일면적 찾기
              </Checkbox>
              <Checkbox
                $isOn={aroundRealDealFilter.is_same_arround2}
                onClick={() =>
                  setAroundRealDealFilter({
                    ...aroundRealDealFilter,
                    is_same_arround2: !aroundRealDealFilter.is_same_arround2,
                  })
                }
              >
                <img
                  src={`/assets/images/check/${aroundRealDealFilter.is_same_arround2 ? 'circle-checked-blue' : 'circle-checked-gray-outline'}.svg`}
                  alt=""
                />
                동일층수 찾기
              </Checkbox>
            </CheckboxWrapper>
          </TitleWithCheckbox>
        </TitleWrapper>
      </ContentItemTitle>
      <Tab
        tab={acitveTab}
        setTab={setAcitveTab}
        setCurrentPage={setCurrentPage}
        isOnlySale={
          !(type === 'e' ? exchangeItemCategory : nearRealPriceData?.ptype) ||
          ['단독', '빌딩', '공장', '창고', '토지'].includes(
            type === 'e'
              ? exchangeItemCategory
              : (nearRealPriceData?.ptype ?? ''),
          ) ||
          itemType === 'L'
        }
      />
      <DistanceWrapper>
        <DistanceBox>
          <DistanceButton
            onClick={() =>
              setAroundRealDealFilter({
                ...aroundRealDealFilter,
                distance: 500,
              })
            }
            selectYN={aroundRealDealFilter.distance === 500}
          >
            500m
          </DistanceButton>
          <DistanceButton
            onClick={() =>
              setAroundRealDealFilter({
                ...aroundRealDealFilter,
                distance: 1000,
              })
            }
            selectYN={aroundRealDealFilter.distance === 1000}
          >
            1km
          </DistanceButton>
          <DistanceButton
            onClick={() =>
              setAroundRealDealFilter({
                ...aroundRealDealFilter,
                distance: 1500,
              })
            }
            selectYN={aroundRealDealFilter.distance === 1500}
          >
            1.5km
          </DistanceButton>
          <DistanceButton
            onClick={() =>
              setAroundRealDealFilter({
                ...aroundRealDealFilter,
                distance: 2000,
              })
            }
            selectYN={aroundRealDealFilter.distance === 2000}
          >
            2km
          </DistanceButton>
        </DistanceBox>
      </DistanceWrapper>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderTop: '1px solid #E5E8EA',
        }}
      >
        {!(type === 'e' ? exchangeItemCategory : nearRealPriceData?.ptype) ||
        ['단독', '빌딩', '공장', '창고', '토지'].includes(
          type === 'e'
            ? exchangeItemCategory
            : (nearRealPriceData?.ptype ?? ''),
        ) ||
        itemType === 'L' ? (
          <table style={{ borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <TableHeadTh width="16%" rowSpan={1}>
                  거래일
                </TableHeadTh>
                <TableHeadTh width="20%" rowSpan={1}>
                  주소(반경)
                </TableHeadTh>
                <TableHeadTh width="23%" colSpan={1}>
                  금액(단가 평/m²)
                </TableHeadTh>
                <TableHeadTh width="23%" rowSpan={1}>
                  면적(평/m²)
                </TableHeadTh>
                <TableHeadTh width="17%" rowSpan={1}>
                  경과연수
                </TableHeadTh>
              </tr>
            </thead>
            <tbody>
              {nearRealPriceList.length > 0 &&
                acitveTab === '매매' &&
                nearRealPriceList.map((data, index) => (
                  <tr style={{ borderBottom: '1px solid #e8e9ea' }} key={index}>
                    <TablebodyTd width="16%">
                      {data.dealdate.split('T')[0]}
                    </TablebodyTd>
                    <TablebodyTd width="20%">
                      {data.region ?? data.legaldong ?? '-'}
                      <br></br>
                      (인근 {data.distance.toLocaleString()}m)
                    </TablebodyTd>
                    <TablebodyTd width="23%">
                      {formatToEokMan(data.dealprice)}
                      <br></br>(
                      {unit === '평'
                        ? formatToEokMan(data.price_per_pyeong)
                        : formatToEokMan(data.price_per_pyeong / 3.3058)}
                      / {unit === '평' ? '평' : 'm²'})
                    </TablebodyTd>
                    <TablebodyTd width="23%">
                      {unit === '평'
                        ? data.pyeong
                        : (data.pyeong * 3.3058).toFixed(1)}
                      {unit === '평' ? '평' : 'm²'}
                    </TablebodyTd>
                    <TablebodyTd width="17%">
                      {data.build_year
                        ? `${calculateElapsedYears(data.build_year)}년`
                        : '-'}
                    </TablebodyTd>
                  </tr>
                ))}
              {nearRealPriceList.length === 0 && NoDataMessage()}
            </tbody>
          </table>
        ) : (
          <table
            style={{
              borderCollapse: 'collapse',
              width: '100%',
            }}
          >
            <thead style={{ width: '100%' }}>
              <tr>
                <TableHeadTh width="16%" rowSpan={1}>
                  거래일
                </TableHeadTh>
                <TableHeadTh width="20%" rowSpan={1}>
                  주소(반경)
                </TableHeadTh>
                <TableHeadTh width="23%" colSpan={1}>
                  금액(단가 평/m²)
                </TableHeadTh>
                <TableHeadTh width="23%" rowSpan={1}>
                  면적(평/m²)
                </TableHeadTh>
                <TableHeadTh width="17%" rowSpan={1}>
                  경과연수
                </TableHeadTh>
              </tr>
            </thead>
            <tbody style={{ width: '100%' }}>
              {nearRealPriceList.length > 0 &&
                acitveTab === '매매' &&
                nearRealPriceList.map((data, index) => (
                  <tr style={{ borderBottom: '1px solid #e8e9ea' }} key={index}>
                    <TablebodyTd width="16%">
                      {data.dealdate.split('T')[0]}
                    </TablebodyTd>
                    <TablebodyTd width="20%">
                      {data.region}
                      <br></br>({data.distance}m)
                    </TablebodyTd>

                    <TablebodyTd width="23%" style={{ textAlign: 'end' }}>
                      {formatToEokMan(data.dealprice)}
                      <br></br>(
                      {unit === '평'
                        ? formatToEokMan(data.price_per_pyeong)
                        : formatToEokMan(data.price_per_pyeong / 3.3058)}
                      / {unit === '평' ? '평' : 'm²'})
                    </TablebodyTd>
                    <TablebodyTd width="23%">
                      {unit === '평'
                        ? data.pyeong
                        : (data.pyeong * 3.3058).toFixed(1)}
                      {unit === '평' ? '평' : 'm²'}
                      <br />(
                      {data.floor > 0 ? data.floor : `B${Math.abs(data.floor)}`}
                      층)
                    </TablebodyTd>
                    <TablebodyTd width="17%">
                      {data.build_year
                        ? `${calculateElapsedYears(data.build_year)}년`
                        : '-'}
                    </TablebodyTd>
                  </tr>
                ))}
              {nearRealPriceList.length > 0 &&
                acitveTab === '전˙월세' &&
                nearRealPriceList.map((data, index) => (
                  <tr style={{ borderBottom: '1px solid #e8e9ea' }} key={index}>
                    <TablebodyTd width="16%">
                      {data.dealdate.split('T')[0]}
                    </TablebodyTd>
                    <TablebodyTd width="20%">
                      {data.region}
                      <br></br>({data.distance}m)
                    </TablebodyTd>
                    <TablebodyTd width="23%">
                      <PriceTagBox>
                        {data.dealprice2 !== 0 ? (
                          <PriceTagRow>
                            <span>{formatToEokMan(data.dealprice)}</span>/
                            <span>{formatToEokMan(data.dealprice2)}</span>
                          </PriceTagRow>
                        ) : (
                          <PriceTagRow>
                            <span>{formatToEokMan(data.dealprice)}</span>
                          </PriceTagRow>
                        )}
                        {/* <br></br> */}
                        <div>
                          {unit === '평'
                            ? formatToEokMan(data.price_per_pyeong)
                            : formatToEokMan(data.price_per_pyeong / 3.3058)}
                          / {unit === '평' ? '평' : 'm²'}
                        </div>
                      </PriceTagBox>
                    </TablebodyTd>
                    <TablebodyTd width="23%">
                      {unit === '평'
                        ? data.pyeong
                        : (data.pyeong * 3.3058).toFixed(1)}
                      {unit === '평' ? '평' : 'm²'}
                      <br></br>(
                      {data.floor > 0 ? data.floor : `B${Math.abs(data.floor)}`}
                      층)
                    </TablebodyTd>
                    <TablebodyTd width="17%">
                      {data.build_year
                        ? `${calculateElapsedYears(data.build_year)}년`
                        : '-'}
                    </TablebodyTd>
                  </tr>
                ))}
              {nearRealPriceList.length === 0 && NoDataMessage()}
            </tbody>
          </table>
        )}
      </div>
      {nearRealPriceList.length > 0 && (
        <Pagination
          removeMargin={true}
          currentPage={currentPage}
          totalPages={Math.ceil(
            Number(
              acitveTab === '매매'
                ? (nearRealPriceData?.sale_total ?? 0)
                : Number(nearRealPriceData?.jeonse_total ?? 0) +
                    Number(nearRealPriceData?.monthly_total ?? 0),
            ) / 6,
          )}
          onPageChange={handlePageChange}
        />
      )}
    </Container>
  );
}

export default NearRealPrice;

function NoDataMessage() {
  return (
    <tr style={{ borderBottom: '1px solid #e8e9ea' }}>
      <TablebodyTd width="100%" colSpan={4}>
        최근 10년 실거래 이력이 없습니다.
      </TablebodyTd>
    </tr>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;
  background: white;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
`;

const TitleContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
`;

const ContentItemTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 23.2px;
  letter-spacing: -0.36px;
  color: #171e26;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;
  align-items: center;
  // div {
  //   display: flex;
  //   flex-direction: row;
  //   align-items: center;
  //   gap: 8px;
  // }
`;

const TitleWithCheckbox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const Checkbox = styled.div<{ $isOn?: boolean }>`
  flex-direction: row;
  cursor: pointer;
  border-radius: 4px;
  padding: 2px 5px 2px 4px;
  display: flex;
  gap: 2px;
  align-items: center;

  font-weight: 500;
  font-size: 12px;
  color: ${({ $isOn }) => ($isOn ? '#008AFF' : '#37383c9c')};

  & > img {
    width: 16px;
    height: 16px;
  }
`;
interface WidthProps {
  width: string;
}

const TableHeadTh = styled.th<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 10px 4px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;
  &:last-child {
    border-right: none;
  }
`;
const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 10px 4px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #222222;

  &:last-child {
    border-right: none;
  }
`;

const BlueTag = styled.span`
  padding: 3px 8px;
  border-radius: 4px;
  background: #f2f7ff;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 15.95px;
  letter-spacing: -0.28px;
  color: #008aff;
`;

const PriceTagBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  // gap: 6px;
`;
const PriceTagRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  // padding: 0 6px;
`;

interface DistanceProps {
  selectYN: boolean;
}
const DistanceButton = styled.div<DistanceProps>`
  padding: 6px 16px;
  border-radius: 9999px;
  background: ${({ selectYN }) => (selectYN ? '#222222' : '#F3F5F7')};
  color: ${({ selectYN }) => (selectYN ? '#fff' : '#989BA2')};
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
`;

const DistanceBox = styled.div`
  display: flex;
  flex-direction: row;
  // background-color: rgba(112, 115, 124, 0.08);
  border-radius: 4px;
  padding: 4px;
  gap: 8px;
`;

const DistanceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  color: #222222;
  font-size: 14px;
  font-family: 'Spoqa Han Sans Neo';
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;
